<!-- SUCCESS/FAIL MESSAGE -->
<ion-row [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }">
  <ion-col size="12">
    <!-- GREEN MESSAGE -->
    <div
      *ngIf="apiResp?.matches?.length > 0; else failureMessage"
      class="message success-message"
      data-cy="image-order-success-text"
    >
      <div class="message-content">
        <div>
          <ion-icon name="checkmark-circle-outline"></ion-icon>
        </div>
        <div>
          <span>{{ 'i18n.imageOrderingPage.successMessage' | translate }}</span>
        </div>
      </div>
    </div>
    <!-- RED MESSAGE -->
    <ng-template #failureMessage>
      <div class="message error-message" data-cy="image-order-error-text">
        <div class="message-content">
          <div>
            <ion-icon name="alert-circle-outline"></ion-icon>
          </div>
          <div>
            <span *ngIf="showFileSizeError">
              {{
                'i18n.imageOrderingPage.errorFileSizeMessage'
                  | translate: { maxFileSize: maxFileSizeMB }
              }}
            </span>
            <span *ngIf="!showFileSizeError && showFileTypeError">
              {{
                'i18n.imageOrderingPage.errorFileTypeMessage'
                  | translate: { fileTypes: allowedFileTypes }
              }}
            </span>
            <span
              *ngIf="
                !showFileSizeError && !showFileTypeError && !!apiResp?.error
              "
            >
              {{ 'i18n.imageOrderingPage.errorMessage' | translate }}
            </span>
            <span
              *ngIf="
                !showFileSizeError && !showFileTypeError && !apiResp?.error
              "
            >
              {{
                'i18n.imageOrderingPage.alternativeMethodMessage' | translate
              }}
              <u (click)="navigateToListsEmitter.emit()">
                {{ 'i18n.imageOrderingPage.list' | translate }}
              </u>
            </span>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-col>
</ion-row>
<!-- RAW RESPONSE -->
<ng-container *ngIf="apiResp?.matches?.length > 0; else failureDescription">
  <ion-row
    [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }"
  >
    <ion-col size="12">
      <h2>
        {{ successPoint1 + '' + successPoint2 }}
      </h2>
    </ion-col>
  </ion-row>
  <ion-row
    [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }"
  >
    <ion-col size="12">
      <p>
        {{ 'i18n.imageOrderingPage.successPoint3' | translate }}
      </p>
    </ion-col>
  </ion-row>
</ng-container>
<!-- SUGGEST FIX -->
<ng-template #failureDescription>
  <ion-row
    [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }"
  >
    <ion-col size="12">
      <ul>
        <li data-cy="image-order-info-text-1">
          {{ 'i18n.imageOrderingPage.bulletPoint1' | translate }}
        </li>
        <br />
        <li data-cy="image-order-info-text-2">
          {{ 'i18n.imageOrderingPage.bulletPoint2' | translate }}
        </li>
      </ul>
      <p [innerHtml]="'i18n.imageOrderingPage.pdfMessage' | translate"></p>
    </ion-col>
  </ion-row>
</ng-template>

<!-- DESKTOP BUTTONS -->
<ion-row
  [ngClass]="{ desktop: isDesktop, tablet: isTablet, mobile: isMobile }"
  *ngIf="!apiResp || apiResp?.matches?.length < 1; else reviewButtons"
>
  <ng-container *ngIf="isDesktop; else mobileButtons">
    <!-- UPLOAD-FILE BUTTON -->
    <ion-button
      data-cy="image-order-upload-button"
      class="btn-upload usf-fill-green-button"
      [ngClass]="{ 'btn-full': isMobile }"
      (click)="uploadFileOptionEmitter.emit()"
    >
      &nbsp;<ion-icon name="cloud-upload"></ion-icon>&nbsp;
      {{ 'i18n.imageOrderingPage.uploadFile' | translate }}&nbsp;
    </ion-button>

    <!-- CAMERA BUTTON -->
    <ion-button
      data-cy="image-order-camera-button"
      class="btn-camera usf-green-link-button"
      [ngClass]="{ 'btn-full': isMobile }"
      [disabled]="!hasCameraAccess"
      (click)="cameraOptionEmitter.emit()"
    >
      &nbsp;<ion-icon name="camera"></ion-icon>&nbsp;
      {{ 'i18n.imageOrderingPage.camera' | translate }}&nbsp;
    </ion-button>
  </ng-container>

  <ng-template #mobileButtons>
    <!-- CAMERA BUTTON -->
    <ion-button
      data-cy="image-order-camera-button"
      class="btn-camera usf-fill-green-button"
      [ngClass]="{ 'btn-full': isMobile }"
      [disabled]="!hasCameraAccess"
      (click)="cameraOptionEmitter.emit()"
    >
      &nbsp;<ion-icon name="camera"></ion-icon>&nbsp;
      {{ 'i18n.imageOrderingPage.camera' | translate }}&nbsp;
    </ion-button>

    <!-- UPLOAD-FILE BUTTON -->
    <ion-button
      data-cy="image-order-upload-button"
      class="btn-upload usf-green-link-button"
      [ngClass]="{ 'btn-full': isMobile }"
      (click)="uploadFileOptionEmitter.emit()"
    >
      &nbsp;<ion-icon name="cloud-upload"></ion-icon>&nbsp;
      {{ 'i18n.imageOrderingPage.uploadFile' | translate }}&nbsp;
    </ion-button>
  </ng-template>
</ion-row>

<ng-template #reviewButtons>
  <ion-row>
    <!-- REVIEW BUTTON -->
    <ion-button
      data-cy="image-order-review-button"
      class="btn-review usf-fill-green-button"
      [ngClass]="{ 'btn-full': isMobile }"
      (click)="navigateToCartEmitter.emit(true)"
    >
      {{ 'i18n.imageOrderingPage.reviewOrder' | translate }}
    </ion-button>

    <!-- ADD MORE BUTTON -->
    <ion-button
      id="image-ordering-options-btn"
      data-cy="image-ordering-options-btn"
      class="usf-green-link-button image-ordering-options-button"
      [ngClass]="{ 'btn-full': isMobile }"
      (click)="showOptions()"
    >
      {{ 'i18n.imageOrderingPage.addMoreItems' | translate }}
      <ion-icon slot="end" name="add-outline"> </ion-icon>
    </ion-button>
    <ion-popover
      *ngIf="isDesktop"
      data-cy="image-ordering-options-popover"
      class="image-ordering-options-popover"
      mode="ios"
      showBackdrop="false"
      trigger="image-ordering-options-btn"
      dismissOnSelect="true"
    >
      <ng-template>
        <app-ellipsis-options-popover
          class="popover-viewport"
          [buttons]="imageOrderingOptionsButtons"
        >
        </app-ellipsis-options-popover>
      </ng-template>
    </ion-popover>
  </ion-row>
</ng-template>

<!-- Image Ordering Options Action Sheet-->
<ion-action-sheet
  class="action-sheet-touch"
  mode="ios"
  data-cy="image-ordering-options-action-sheet"
  [isOpen]="imageOrderingOptionsActionSheetIsOpen"
  [buttons]="imageOrderingOptionsButtons"
  (didDismiss)="imageOrderingOptionsActionSheetIsOpen = false"
></ion-action-sheet>
